import React from 'react';
import styles from './App.module.css';
import CRTOverlay from './components/CRTOverlay';
import TypewriterTagline from './components/TypewriterTagline';
import DirectorySection from './components/DirectorySection';
import FlaskWidget from './components/FlaskWidget';
import {
  CornerMarkers,
  BeakerBadge,
  SectionLabel,
  FigureFrame,
  TickerBand,
} from './components/Decorative';

const TICKER_TEXT = 'EXPERIMENT * ITERATE * SHIP * OBSERVE * REPEAT * ';

function App() {
  return (
    <>
      <CRTOverlay />
      <div className={styles.badge}>
        <BeakerBadge />
      </div>
      <main>
        <section className={`${styles.section} ${styles.hero}`}>
          <CornerMarkers />
          <div className={styles.heroContent}>
            <h1 className={styles.wordmark}>Aronis Labs</h1>
            <TypewriterTagline />
          </div>
        </section>
        <section className={`${styles.section} ${styles.widget}`}>
          <CornerMarkers />
          <div className={styles.contentColumn}>
            <SectionLabel label="INTERACTIVE" />
            <div className={styles.frameWrapper}>
              <FigureFrame label="FIG. 1">
                <div className={styles.frameBody}>
                  <FlaskWidget />
                </div>
              </FigureFrame>
            </div>
          </div>
        </section>
        <div className={styles.ticker}>
          <TickerBand text={TICKER_TEXT} />
        </div>
        <section className={`${styles.section} ${styles.directory}`}>
          <CornerMarkers />
          <div className={styles.directoryColumn}>
            <SectionLabel label="DIRECTORY" />
            <DirectorySection />
          </div>
        </section>
      </main>
    </>
  );
}

export default App;
